import {
  AppointmentTypeLocation,
  DefaultTestLocationList,
} from './appointmentTypeLocation';
import {
  AppointmentTypeQuestion,
  DefaultTestQuestionList,
} from './appointmentTypeQuestion';

export interface AppointmentType {
  id?: string;
  name?: string;
  description?: string;
  requireComment: boolean;
  bornBeforeDate: string;
  bornAfterDate: string;
  locationList?: AppointmentTypeLocation[];
  questions?: AppointmentTypeQuestion[];
}

///////////////////////////////////////////////
// defaults for testing
export const DefaultAppointmentTypeList = new Array(4)
  .fill(undefined)
  .map((item, index) => ({
    id: `apptType${index}`,
    name: `Appointment Type ${index}`,
    description:
      index === 1
        ? `Value ${index} - A short description goes here.`
        : `Value ${index} - A short description goes here.  Text should be at a maximum of 100 characters.`,
    bornBeforeDate: '01-01-2025',
    bornAfterDate: '01-01-1825',
    requireComment: false,
    locationList: DefaultTestLocationList,
    questions: DefaultTestQuestionList,
  }));
